import { signerFlagsFor } from './selectSignerFields';

// Builds the (url, body) for the sign submit. CP links (document_type 6 / collab_phys_id present,
// or explicit mode) submit to the CP endpoint with collab_phys_id and NO operator_id.
// collab-operator links (document_type 7, or explicit mode) are the operator's own half
// of a two-party Collaborative Agreement and submit to their own endpoint with BOTH
// operator_id and collab_phys_id, plus state — checked before the isCp check below,
// since a doc_type 7 link also carries collab_phys_id and would otherwise misroute there.
//
// The operator branch reproduces the body currently posted by operatorSign.jsx's
// uploadGeneratedPdf (~:256-271) exactly, including the unconditional
// `first_name + " " + last_name` string concatenation (not a presence check) — that is
// today's real behavior and must not change.
// A loaded link's own type (6 or 7) wins over the route's mode, as on the page: signerFlagsFor.
export function buildSignSubmit({ serverBaseUrl, mode, signLink, finalDocumentUrl, dateCreated, dateSigned }) {
  const { isCp, isCollabOperator } = signerFlagsFor(mode, signLink);
  if (isCollabOperator) {
    const op = signLink?.operator_details || {};
    return {
      isCp: false,
      url: `${serverBaseUrl}/submit_collab_operator_sign_link`,
      body: {
        sign_secret_id: signLink?.sign_secret_id,
        operator_id: signLink?.operator_id,
        collab_phys_id: signLink?.collab_phys_id,
        state: signLink?.state,
        template_id: signLink?.template_id,
        final_document_url: finalDocumentUrl,
        full_name: op?.first_name + ' ' + op?.last_name,
        phone_number: op?.phone_number,
        email: op?.email,
        date_created: dateCreated,
        date_signed: dateSigned,
      },
    };
  }
  if (isCp) {
    const cp = signLink?.collab_phys_details || {};
    return {
      isCp: true,
      url: `${serverBaseUrl}/submit_collab_phys_sign_link`,
      body: {
        sign_secret_id: signLink?.sign_secret_id,
        collab_phys_id: signLink?.collab_phys_id,
        template_id: signLink?.template_id,
        final_document_url: finalDocumentUrl,
        full_name: cp?.name,
        phone_number: cp?.phone_number,
        email: cp?.email,
        date_created: dateCreated,
        date_signed: dateSigned,
      },
    };
  }
  return {
    isCp: false,
    url: `${serverBaseUrl}/submit_operator_sign_link`,
    body: {
      sign_secret_id: signLink?.sign_secret_id,
      final_document_url: finalDocumentUrl,
      template_id: signLink?.template_id,
      operator_id: signLink?.operator_id,
      date_created: dateCreated,
      full_name:
        signLink?.operator_details?.first_name +
        " " +
        signLink?.operator_details?.last_name,
      phone_number: signLink?.operator_details?.phone_number,
      email: signLink?.operator_details?.email,
      date_signed: dateSigned,
    },
  };
}
